
import {initWebComponent} from "@/helpers/web-component-helper";
import {clickAutoComplete, initAutoComplete} from "@/helpers/autocomplete-helper";
import {goToLocationByAddressID, removeNotificationMarker} from "@/helpers/ol/ol-route-helper";
import {goToCoordinate} from "@/helpers/ol/ol-coordinate-helper";
import {getWfsInfoByDomainIDAndColumn} from "@/http/services/http-services-wfs";
import {applyFilter, clearActiveFilter, getActiveFilter, getFilterByKey} from "@/helpers/filter/filter-helper";
import {unblockUi} from "@/modules/elements-blockui";
import {loadInfo} from "@/helpers/layer/info/layer-info-info-helper";
import {removeAllActiveClasses} from "@/helpers/layer-menu-helper";
import {
    addClassBySelector,
    getBySelector,
    hideElementsBySelector, removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {clearGeoJsonLayers} from "@/helpers/ol/ol-geo-json-helper";
import {getWfsByColumn} from "@/helpers/ol/ol-http-helper";
import {isMobile} from "@/helpers/mobile-helper";

const template = document.createElement('template');

export class AutoCompleteComponent extends HTMLElement {
    constructor() {
        super();

        let placeHolder = window.settings.Snelzoeken
        if (!placeHolder) {
            placeHolder = 'Zoek op adres...'
        }
        template.innerHTML = `
        <input class="form-control mr-sm-2 iptSearchAddress pl-2" type="text" id="iptHomeFindAddress" placeholder="` + placeHolder + `" style="border-bottom: 0px">
        <span class="fa fa-times position-absolute cursor-pointer d-none" style="right: 55px;top: 12px;z-index: 100;font-size:10px">
        </span>
        `;

        initWebComponent(this, template)

        const input = this.querySelector('input')

        initAutoComplete(this.querySelector('input'))

        if (isMobile()) {
            this.addEventListener("focusin", (event) => {
                hideElementsBySelector('.header-search-hide')
                addClassBySelector('auto-complete', 'focus')
            });

            this.addEventListener("focusout", (event) => {
                showElementsBySelector('.header-search-hide')
                removeClassBySelector('auto-complete', 'focus')
            });
        }

        this.addEventListener('keyup', (evt) => {

            if(evt.code === 'Enter' || evt.code === 'NumpadEnter') {
                clickAutoComplete()
            }

            if(evt.target.value) {
                this.querySelector('span').classList.remove('d-none')
            } else {
                this.querySelector('span').classList.add('d-none')
                removeNotificationMarker()
            }
        })

        this.querySelector('span').addEventListener('click', () => {
            input.value = ''
            this.querySelector('span').classList.add('d-none')
            removeNotificationMarker()
        })
    }
}

